<ng-template #hotspot let-key>
    <span class="slot-hotspot" *ngIf="hotspots[key]" [ngClass]="'hotspot-' + key"
        [class.active]="key === highlightSlot" [class.hovered]="key === hoverSlot"
        (mouseenter)="slotHover.emit(key)" (mouseleave)="slotHover.emit(null)" (click)="onSlotClick(key, $event)">
        <span class="hotspot-label">{{ slotLabels[key] | translate }}</span>
    </span>
</ng-template>

<div class="analyte-cell"
    [class.design-mode]="designMode"
    [class.bulk-mode]="bulkMode"
    [class.selected]="bulkMode && selected"
    [style.background-color]="profile.usesHealthRiskScore ? register.card?.color : null">
    @if (bulkMode) {
        <label class="cell-checkbox" (click)="$event.stopPropagation()">
            <input type="checkbox" [checked]="selected" [disabled]="bulkLoading" (change)="onCheckboxChange($event)">
            <span class="cell-checkbox-box"></span>
        </label>
        <div class="bulk-div"></div>
    }
    <div class="left-block"
        [style.background-color]="profile.usesHealthRiskScore ? null : register.card?.color">
        <div class="quant-icon d-flex">
            @switch (register.methodOfAssessment) {
                @case (assessmentMethodEnum.Quantitative) {
                    <span class="quant-image-badge d-block mt-1">
                        <img class="quant-image" src="assets/images/quant-icon.svg" alt="bars">
                    </span>
                }
                @case (assessmentMethodEnum.Qualitative) {
                    <span class="bordered-span quant-qual-label d-block mt-1">
                        {{ 'QUAL' | translate }}
                    </span>
                }
                @case (assessmentMethodEnum.HazardDoesNotApply) {
                    <span class="hazard-title small" [title]="register.title ?? ''">
                        {{register.title}} </span>
                }
            }

            @if ((register.card?.main || register.card?.below) && register.methodOfAssessment !== assessmentMethodEnum.HazardDoesNotApply) {
                <div class="values">
                    @if (register.card?.main; as main) {
                        @if (main.iconSrc !== undefined) {
                            <span class="slot-icon value-line main-value" [title]="main.tooltip"><img [src]="main.iconSrc"></span>
                        } @else if (main.text) {
                            <span class="value-line main-value" [title]="main.tooltip">{{ main.text }}</span>
                        }
                    }
                    @if (register.card?.below; as below) {
                        @if (below.iconSrc !== undefined) {
                            <span class="slot-icon value-line line-below" [title]="below.tooltip"><img [src]="below.iconSrc"></span>
                        } @else if (below.text) {
                            <span class="value-line line-below" [title]="below.tooltip">{{ below.text }}</span>
                        }
                    }
                </div>
            }
        </div>
        @if (designMode) {
            <ng-container *ngTemplateOutlet="hotspot; context: { $implicit: 'main' }"></ng-container>
            <ng-container *ngTemplateOutlet="hotspot; context: { $implicit: 'below' }"></ng-container>
        }
    </div>
    @if (profile.usesExposureAssessment) {
        <div class="right-block standard-right" [style.background-color]="register.card?.cornerColor">
            @if (register.card?.topRight; as topRight) {
                @if (topRight.iconSrc !== undefined) {
                    <span class="slot-icon right-slot top-right" [title]="topRight.tooltip"><img [src]="topRight.iconSrc"></span>
                } @else if (topRight.text) {
                    <span class="right-slot top-right" [title]="topRight.tooltip">{{ topRight.text }}</span>
                }
            } @else {
                <span class="top-spacer"></span>
            }
            @if (register.card?.bottomRight; as bottomRight) {
                @if (bottomRight.iconSrc !== undefined) {
                    <span class="slot-icon right-slot bottom-right" [title]="bottomRight.tooltip"><img [src]="bottomRight.iconSrc"></span>
                } @else if (bottomRight.text) {
                    <span class="right-slot bottom-right" [title]="bottomRight.tooltip">{{ bottomRight.text }}</span>
                }
            }
            @if (designMode) {
                <ng-container *ngTemplateOutlet="hotspot; context: { $implicit: 'topRight' }"></ng-container>
                <ng-container *ngTemplateOutlet="hotspot; context: { $implicit: 'bottomRight' }"></ng-container>
            }
        </div>
    }
    @if (profile.usesHealthRiskScore) {
        <div class="right-block">
            @if (register.card?.topRight; as topRight) {
                @if (topRight.iconSrc !== undefined) {
                    <span class="slot-icon right-slot top-right" [title]="topRight.tooltip"><img [src]="topRight.iconSrc"></span>
                } @else if (topRight.text) {
                    <span class="right-slot top-right" [title]="topRight.tooltip">{{ topRight.text }}</span>
                }
            } @else {
                <span class="top-spacer"></span>
            }
            @if (canEdit) {
                <i class="edit-icon material-icons material-grey-icon"
                    [class.disabled-icon]="isParentAssessmentApproved || bulkLoading"
                    [title]="(isParentAssessmentApproved ? 'This assessment is approved, so its registers are read-only. Un-approve the assessment to edit them.' : 'Edit') | translate"
                    (click)="onEditClick()">edit</i>
            }
            @if (designMode) {
                <ng-container *ngTemplateOutlet="hotspot; context: { $implicit: 'topRight' }"></ng-container>
            }
        </div>
    }
</div>
